import React from "react";
import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../../consts/Constants.js";
import Style from "../../../../../styles/js/StyleCallList.js";
import IconButton from '@mui/material/IconButton';
import DescriptionIcon from '@mui/icons-material/Description';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Tooltip from '@mui/material/Tooltip';
import CircularProgressWithLabel from "../../../../../components/common/CircularProgressWithLabel.js";
import service from '../../../../../plas/services/calls/service';

export default function InputPreview( { input } ) {

  const style = Style();
  const [downloadingA, setDownloadingA] = React.useState({}); // Descargas de auxiliary files

  const getAuxiliaryFile = (form, input, file) => {    
    setDownloadingA(prevState => {
      const state = { ...prevState };
      state[file.id] = 0;
      return state;
    });

    service.api.auxiliaryFiles.get(form.id,input.id,file.id, {
      success: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      },
      error: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      } ,
      onDownloadProgress: (value) => {
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = value;
          return state;
        });
      }
    });
  }

  return (
    <div className={style.row}>
      <Card style={{ marginTop: "15px", marginBottom: "15px"}}>
        <div>
          <div className={style.itemHeader} >
            <Typography className={style.titleInitial}>
              {input.name}
            </Typography>
          </div>
          <div style={{ paddingLeft: "12px", paddingRight: "12px", textAlign: "left"}}>
            <div className={style.itemContent}>
              <Typography style={{whiteSpace: "pre-line"}}>
                {input.description}
              </Typography>
                { input.auxiliaryFiles.length !== 0 ? (
                <Stack style={{marginTop: "10px"}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                    <Typography style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center", width: "70px"}}>
                    Archivos<br/>auxiliares
                  </Typography>
                  { input.auxiliaryFiles.map((file) => (
                    <div>
                    { downloadingA[file.id] !== undefined ? 
                      (
                      <Stack alignItems="center" style={{width:"110px"}}>
                        <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={downloadingA[file.id]} />
                      </Stack>)
                      :(
                      <Stack alignItems="center" style={{width:"110px"}}>
                       <IconButton size="large" width="50px"  height="50px" onClick={ () => { getAuxiliaryFile(input,file); }} >
                          <DescriptionIcon fontSize="inherit" />
                        </IconButton>
                        <Tooltip title={file.bin.name}>
                          <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"100%", textAlign:"center", overflow:"hidden"}}>{file.bin.name}</span>
                        </Tooltip>
                      </Stack>)
                    }
                    </div>
                    ))
                  }
                </Stack>) : null
                }
            </div>
          </div>
          <div style={{ paddingLeft: "12px", paddingRight: "12px", textAlign: "left", background: Constants.COLOR_GRAY_ULTRA_LIGHT}}>
            <div className={style.itemContent}>
                <Stack style={{marginTop: "10px"}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                  <Typography style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center", width: "70px"}}>
                    Archivos<br/>adjuntos
                  </Typography>
                  <Stack alignItems="center" style={{width:"110px"}}>
                    <IconButton>
                      <UploadFileIcon fontSize="inherit" />
                    </IconButton>
                    <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"100%", textAlign:"center"}}>Subir archivo</span>
                  </Stack>
                </Stack>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
